import React, { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { fetchQuotes } from '../services/api';
import { stockTickerData } from '../data/mock';

const formatPrice = (n) => {
  if (n >= 1000) {
    return `$${n.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
  }
  return `$${n.toFixed(2)}`;
};

const StockTicker = () => {
  const [quotes, setQuotes] = useState(stockTickerData.map((s) => ({
    symbol: s.symbol,
    price: parseFloat(String(s.price).replace(/[^0-9.-]/g, '')) || 0,
    change: parseFloat(s.delta) || 0,
    changePercent: parseFloat(String(s.change).replace('%', '')) || 0,
    up: s.up,
    category: 'stocks',
  })));

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const data = await fetchQuotes();
        if (!cancelled && data.length) setQuotes(data);
      } catch (err) {
        console.warn('Stock ticker fetch failed, keeping fallback:', err?.message || err);
      }
    };
    load();
    const interval = setInterval(load, 60_000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  const items = [...quotes, ...quotes];

  return (
    <div className="w-full bg-[#0b1a2e] text-white overflow-hidden border-b border-white/5">
      <div className="relative flex whitespace-nowrap ticker-track py-3">
        {items.map((s, i) => (
          <div
            key={`${s.symbol}-${i}`}
            className="flex items-center gap-3 px-8 shrink-0 text-sm font-medium"
          >
            <span className="tracking-wide text-white/90">{s.symbol}</span>
            <span className="font-semibold">{formatPrice(s.price)}</span>
            <span
              className={`flex items-center gap-1 text-xs ${
                s.up ? 'text-emerald-400' : 'text-red-400'
              }`}
            >
              {s.up ? (
                <TrendingUp className="w-3.5 h-3.5" />
              ) : (
                <TrendingDown className="w-3.5 h-3.5" />
              )}
              {s.up ? '' : ''}{Math.abs(s.changePercent).toFixed(2)}%
              <span className="text-white/50">
                ({s.change > 0 ? '+' : ''}{s.change.toFixed(2)})
              </span>
            </span>
            <span className="h-3 w-px bg-white/15 ml-4" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockTicker;
